import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const ReallocationLogPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.ReallocationLog />
    </div>
  );
};

export default ReallocationLogPage;
